// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"CommentsModalBody_modalBody__2Ht8l"};